function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 360,
    style: {
      fill: "#FF4F19"
    },
    width: 48,
    height: 120
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9600"
    },
    d: "M319.969,448h-128c-13.234,0-24,10.766-24,24v32c0,4.422,3.578,8,8,8h160c4.422,0,8-3.578,8-8v-32 C343.969,458.765,333.203,448,319.969,448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD200"
    },
    d: "M319.969,448H256v64h79.969c4.422,0,8-3.578,8-8v-32C343.969,458.765,333.203,448,319.969,448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9600"
    },
    d: "M135.992,304.008c-2.102,0-4.242-0.422-6.297-1.305C52.625,269.68,0.516,183.5,0.031,88.273 c-0.047-8.609,3.273-16.711,9.352-22.82C15.445,59.359,23.516,56,32.094,56H128c8.836,0,16,7.164,16,16s-7.164,16-16,16H32.094 c0.359,82.789,44.672,157.211,110.211,185.297c8.117,3.477,11.883,12.883,8.398,21.008 C148.109,300.367,142.203,304.008,135.992,304.008z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9600"
    },
    d: "M376.008,304.008c-6.211,0-12.117-3.641-14.711-9.703c-3.484-8.125,0.281-17.531,8.398-21.008 c65.539-28.086,109.852-102.508,110.273-185.18L384,88c-8.836,0-16-7.164-16-16s7.164-16,16-16h95.906 c8.578,0,16.648,3.359,22.711,9.453c6.078,6.109,9.398,14.211,9.352,22.828c-0.484,95.219-52.594,181.398-129.664,214.422 C380.25,303.586,378.109,304.008,376.008,304.008z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD200"
    },
    d: "M391.969,8h-272c-4.422,0-8,3.578-8,8v216c0,79.398,64.602,144,144,144s144-64.602,144-144V16 C399.969,11.578,396.39,8,391.969,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#646464",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M127.972,272.812"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9600"
    },
    d: "M256,8H119.969c-4.422,0-8,3.578-8,8v216c0,79.398,64.602,144,144,144 c0.011,0,0.021-0.001,0.031-0.001V8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD200"
    },
    d: "M266.787,111.858l15.531,47.799h50.259c11.017,0,15.597,14.098,6.685,20.573l-40.66,29.541 l15.531,47.799c3.404,10.478-8.588,19.19-17.5,12.715l-40.66-29.541l-40.66,29.541c-8.913,6.476-20.905-2.237-17.501-12.715 l15.531-47.799l-40.66-29.541c-8.913-6.476-4.332-20.573,6.685-20.573h50.259l15.531-47.799 C248.559,101.381,263.382,101.381,266.787,111.858z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M332.577,159.657h-50.259l-15.531-47.799c-1.698-5.228-6.24-7.843-10.787-7.854v136.762 l40.631,29.52c8.913,6.476,20.905-2.237,17.5-12.715l-15.531-47.799l40.66-29.541 C348.174,173.755,343.593,159.657,332.577,159.657z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4F19"
    },
    d: "M112,32c-8.8,0-16-7.2-16-16l0,0c0-8.8,7.2-16,16-16h288c8.8,0,16,7.2,16,16l0,0 c0,8.8-7.2,16-16,16H112z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwards);
export default __webpack_public_path__ + "static/media/Awards.0becdd7aa56b2d1dbbb6194f35c0018d.svg";
export { ForwardRef as ReactComponent };